// extracted by mini-css-extract-plugin
export default {"header":"C68ge","backButton":"qmAEy","searchInputContainer":"SSBju","input":"PDMl0","icon":"RsC07"};